module.exports = __webpack_public_path__ + "public/img/header-logo.609906b2.svg";